import React from "react"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "./_base/TwoColumnHeroWithImageRight"

import WPCta from "./_base/WPCta"

import { ChildSelector } from "../helpers/ChildSelector"

import * as sectionImageRightStyles from "../styles/SectionImageRight.module.css"

export default function SectionImageRight(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `section-rightImage-title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const subTitle = ChildSelector.select(
    content,
    `section-rightImage-subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const attachment = ChildSelector.select(
    content,
    `section-rightImage-attachment`,
    ChildSelector.SELECTOR_TYPE.INNER_HTML,
  )

  const textStack = content.childNodes
    .filter(node => node.classNames === "section-rightImage-content")
    .map(t => t.innerHTML)

  const ctas = ChildSelector.select(
    content,
    `conference-btn`,
    ChildSelector.SELECTOR_TYPE.ARRAY,
  ).map(cta => ({ childNodes: [cta] }))

  return (
    <div
      className={`row ${props.className} ${sectionImageRightStyles.wrapper}`}
    >
      <div className={`col-12 ${sectionImageRightStyles.ctaConferenceWrapper}`}>
        {ctas &&
          ctas.map((cta, idx) => (
            <WPCta
              key={idx}
              holder={cta}
              selector={`conference-btn`}
              pageContext={props.pageContext}
              translate={false}
              className={`${sectionImageRightStyles.conferenceCta}`}
            />
          ))}
      </div>
      <TwoColumnHeroWithImageRight
        contentClass={sectionImageRightStyles.content}
        imageHolder={content}
        imageSelector={`section-rightImage-media`}
        imageClass={sectionImageRightStyles.backgroundImage}
        className={sectionImageRightStyles.wrapper}
        mode={CONTAINMENT_MODE.normal}
      >
        <h1
          className={sectionImageRightStyles.title}
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <h3
          className={sectionImageRightStyles.subTitle}
          dangerouslySetInnerHTML={{
            __html: subTitle,
          }}
        />
        {textStack.map((t, idx) => (
          <p
            className={sectionImageRightStyles.main}
            key={idx}
            dangerouslySetInnerHTML={{ __html: t }}
          />
        ))}
        <div
          className={`row ${props.className} ${sectionImageRightStyles.ctaWrapper}`}
        >
          <div className={`${sectionImageRightStyles.ctaGroup}`}>
            <WPCta
              holder={content}
              selector={`section-rightImage-cta`}
              className={`${sectionImageRightStyles.cta}`}
              pageContext={props.pageContext}
              modals={props.modals}
            />
            {attachment && (
              <p
                className={`${sectionImageRightStyles.attachment}`}
                dangerouslySetInnerHTML={{ __html: attachment }}
              />
            )}
          </div>
        </div>
      </TwoColumnHeroWithImageRight>
    </div>
  )
}
